import React from 'react';
import { Printer } from 'lucide-react';

const PrinterLoader = () => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    backdropFilter: 'blur(4px)',
    WebkitBackdropFilter: 'blur(4px)',
    zIndex: 9999,
    color: 'var(--color-primary)'
  }}>
    <div style={{ position: 'relative', width: '64px', height: '64px', display: 'flex', justifyContent: 'center' }}>
      <Printer size={48} style={{ animation: 'bounce 1s infinite alternate' }} />
      <div style={{ 
        position: 'absolute', 
        bottom: '-10px', 
        left: '50%', 
        transform: 'translateX(-50%)', 
        width: '40px', 
        height: '6px', 
        backgroundColor: '#e2e8f0', 
        borderRadius: '3px',
        overflow: 'hidden'
      }}>
        <div style={{ 
          width: '100%', 
          height: '100%', 
          backgroundColor: 'var(--color-primary)', 
          animation: 'print-progress 1.5s infinite linear' 
        }} />
      </div>
    </div>
    <div style={{ marginTop: '1.5rem', fontWeight: '600', animation: 'pulse 1.5s infinite', fontSize: '1.1rem' }}>
      Loading Data...
    </div>
    <style>{`
      @keyframes bounce {
        0% { transform: translateY(0); }
        100% { transform: translateY(-5px); }
      }
      @keyframes print-progress {
        0% { transform: translateX(-100%); }
        100% { transform: translateX(100%); }
      }
      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.5; }
      }
    `}</style>
  </div>
);

export default PrinterLoader;
